<template>
  <div class="d-flex align-items-center overflow-hidden">
    <i class="kr-icon mx-2"></i>
    <div class="text-truncate label" :title="item.label" v-if="item" v-no-capture>
      {{ item.label }}
    </div>
    <div class="shine" v-else></div>
  </div>
</template>

<script>
/**
 * This provides the template for the selected items in KR filter
 */
export default {
  name: 'KrPillTemplate',
  props: ['item']
}
</script>

<style lang="scss" scoped>
.label {
  max-width: 120px;
}
.shine {
  width: 60px;
  height: 21px;
}
</style>
